"use client";

import type { FooterLinkProps } from "../../types/footer-links";

import { trackFooterLinkClickEvent } from "@homeinstead/analytics";
import { SquareArrowOutUpRight } from "lucide-react";
import { Link as LinkBase } from "../Link";

/**
 * A link component styled for use in the footer, with click tracking.
 */
const FooterLink = ({
  href,
  onClick,
  children,
  target,
  ...props
}: FooterLinkProps) => {
  const handleClick: FooterLinkProps["onClick"] = (event) => {
    trackFooterLinkClickEvent({
      link_title: (event.target as HTMLElement)?.textContent || "",
      target_url: href,
    });

    onClick?.(event);
  };

  return (
    <LinkBase
      href={href}
      target={target}
      variant="footer"
      {...props}
      onClick={handleClick}
    >
      {children}
      {target === "_blank" && (
        <SquareArrowOutUpRight className="ml-1 h-4 w-4" />
      )}
    </LinkBase>
  );
};

export { FooterLink };
